import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import useStore from "../../../context/useStore";
import vehicleTools from "../../../helpers/vehicleTools";
import useTVA from "../../../hooks/useInit/useTVA";
import useRoleStyle from "./hooks/useRoleStyle";
import QuotationHeader from "./QuotationHeader";
import QuotationTable from "./QuotationTable";
import ToggleDetailButton from "./ToggleDetailButton";
import QuotationDetailTable from "./QuotationDetailTable";
import QuotationLineGutter from "./QuotationLineGutter";
import styles from "./QuotationLine.module.scss";

const ContractFinalValues = ({
  quotation,
  dossierUuid,
  rlVehicleChange,
  rlChange,
  applyMarginFromFinanceRent,
  index,
  setQuotationStatus,
  deleteQuotation,
  match,
  setQuotationOpened,
  toggleOverlay,
  overlayOpened,
  navQuotation,
  totalQuotation,
  hideKeys,
  openPdf,
  setQuotationSelected,
  isCreate,
  duplicateQuotation,
  changeLineOrder,
  tableWidth,
  clientUuid,
  onOpenFinanceModal,
  financeStatus,
}) => {
  const [state] = useStore();
  const [firstLoad, setFirstLoad] = useState(true);
  const [, setOverlayHeight] = useState(0);
  const [mentionSel, setMentionSel] = useState("");
  const { doesToggleProtectedFields } = useRoleStyle();

  let showDetail = overlayOpened == index || false;
  var tireData = state.tire.items;

  var constantData = state.constant.items;
  var { vehicle } = quotation;
  const [locks, setLocks] = useState({
    insuranceHT: quotation.uuid ? true : false,
    insuranceFinLoss: quotation.uuid ? true : false,
  });
  let funding = [
    {
      name: "financeRate",
      symbol: "%",
      label: "Taux de financement",
      defaultValue: constantData.FINANCE_RATE_DEFAULT,
    },
    { name: "firstRentInput", label: "Apport 1er Loyer" },
  ];
  const { getTVAByCatalog } = useTVA();
  const { TVA, TVA_INVERT } = getTVAByCatalog(quotation.vehicle.catalog.uuid);
  var basePrices = vehicleTools.calcVehiclePrices(
    vehicle,
    TVA,
    TVA_INVERT,
    true
  );
  var pricePublicTTC = vehicle.priceTTC;
  var investAmtHT = quotation.investAmtHT
    ? quotation.investAmtHT
    : vehicleTools.calcInvestAmtHT(quotation, TVA, TVA_INVERT);

  var priceNetTTC = basePrices.priceTotalTTC;
  var financeRentCalc = vehicleTools.calcFinanceRent(quotation, TVA_INVERT);
  var insuranceHTCalc = vehicleTools.calcInsuranceHT(quotation);
  var insuranceFinLossCalc = vehicleTools.calcInsuranceFinLoss(quotation);
  var totalRentHTCalc = vehicleTools.calcTotalRentHTCalc(quotation);
  var totalRentTTCCalc = vehicleTools.calcPriceTTC(quotation.totalRentHT, TVA);
  var applicationFeeCalc = vehicleTools.calcApplicationFee(
    investAmtHT,
    constantData.APPLICATION_FEES
  );
  var baseRentHT =
    financeRentCalc +
    parseFloat(quotation.maintenanceValueFinal) +
    parseFloat(quotation.marginTTC);
  baseRentHT = isNaN(baseRentHT) ? 0 : Math.round(baseRentHT * 100) / 100;
  var totalBenefits = 0;
  quotation.benefits.forEach((b) => {
    totalBenefits += parseFloat(b.priceHT);
  });

  useEffect(() => {
    if (quotation.uuid) {
      setLocks({ insuranceHT: true, insuranceFinLoss: true });
    } else {
      setLocks({ insuranceHT: false, insuranceFinLoss: false });
    }
  }, [quotation]);
  useEffect(() => {
    if (
      (quotation.financeRent === "0" ||
        quotation.financeRent != financeRentCalc) &&
      !firstLoad
    ) {
      rlChange({ target: { name: "financeRent", value: financeRentCalc } });
    }
  }, [financeRentCalc]);
  useEffect(() => {
    if (
      (quotation.insuranceHT === "0" ||
        quotation.insuranceHT != insuranceHTCalc) &&
      !locks.insuranceHT &&
      !firstLoad
    ) {
      rlChange({ target: { name: "insuranceHT", value: insuranceHTCalc } });
    }
  }, [insuranceHTCalc]);
  useEffect(() => {
    if (
      (quotation.insuranceFinLoss === "0" ||
        quotation.insuranceFinLoss != insuranceFinLossCalc) &&
      !locks.insuranceFinLoss &&
      !firstLoad
    ) {
      rlChange({
        target: { name: "insuranceFinLoss", value: insuranceFinLossCalc },
      });
    }
  }, [insuranceFinLossCalc]);
  useEffect(() => {
    if (
      (quotation.totalRentHT === "0" ||
        quotation.totalRentHT != totalRentHTCalc) &&
      !firstLoad
    ) {
      rlChange({
        target: { name: "totalRentHT", value: totalRentHTCalc },
      });
    }
  }, [totalRentHTCalc]);
  useEffect(() => {
    if (
      (quotation.totalRentTTC === "0" ||
        quotation.totalRentTTC != totalRentTTCCalc) &&
      !firstLoad
    ) {
      rlChange({
        target: { name: "totalRentTTC", value: totalRentTTCCalc },
      });
    }
  }, [totalRentTTCCalc]);
  useEffect(() => {
    if (
      (quotation.applicationFee === "0" ||
        quotation.applicationFee != applicationFeeCalc) &&
      !firstLoad
    ) {
      rlChange({
        target: { name: "applicationFee", value: applicationFeeCalc },
      });
    }
  }, [applicationFeeCalc]);

  useEffect(() => {
    if (
      (quotation.baseRentHT === "0" || quotation.baseRentHT != baseRentHT) &&
      !firstLoad
    ) {
      rlChange({
        target: { name: "baseRentHT", value: baseRentHT },
      });
    }
  }, [baseRentHT]);

  if (quotation.vehicle.pricePublicTTC === "0") {
    rlVehicleChange({
      target: { name: "pricePublicTTC", value: pricePublicTTC },
    });
  }
  if (
    quotation.vehicle.investAmtHT === "0" ||
    quotation.vehicle.investAmtHT != investAmtHT
  ) {
    rlVehicleChange({ target: { name: "investAmtHT", value: investAmtHT } });
  }
  if (
    quotation.vehicle.priceNetTTC === "0" ||
    quotation.vehicle.priceNetTTC != priceNetTTC
  ) {
    rlVehicleChange({ target: { name: "priceNetTTC", value: priceNetTTC } });
  }
  if (quotation.baseRentHT === "0" || quotation.baseRentHT != baseRentHT) {
    rlChange({ target: { name: "baseRentHT", value: baseRentHT } });
  }
  if (quotation.marginTTCRate > 0 && quotation.marginTTC == 0) {
    rlChange({
      target: { name: "marginTTCRate", value: quotation.marginTTCRate },
    });
  }

  useEffect(() => {
    setFirstLoad(false);
    setOverlayHeight(document.getElementById("trrl" + index).clientHeight);
  });

  function resetDefault(v, d) {
    rlChange({ target: { name: v, value: d } });
  }
  function addMention() {
    quotation.mentions.push({ name: mentionSel });
    rlChange({ target: { name: "mentions", value: quotation.mentions } });
  }
  function updateLocks(name) {
    var ulocks = JSON.parse(JSON.stringify(locks));
    ulocks[name] = !ulocks[name];
    setLocks(ulocks);
  }

  const onToggleDetails = () => {
    toggleOverlay(index, !showDetail);
  };

  var shouldShowOverlay = overlayOpened == index && overlayOpened != null;

  var shouldHideRow =
    (overlayOpened != null && overlayOpened != index) ||
    quotation.status.id == 3;

  var style = { position: "relative" };
  var overOverlay = { position: "relative", zIndex: 10 };
  hideKeys.includes(index)
    ? (style.display = "none")
    : (style.display = "table-row");

  return (
    <tr
      id={"trrl" + index}
      style={style}
      className={"big-table   " + (shouldShowOverlay ? "tr-front" : "tr-mask ")}
    >
      <td colSpan="13" className="border-0 px-0">
        <div className={styles.lineCard}>
          <div className={styles.lineTop}>
            <QuotationLineGutter
              index={index}
              quotation={quotation}
              changeLineOrder={changeLineOrder}
              setQuotationSelected={setQuotationSelected}
              overOverlay={overOverlay}
            />
            <div className={styles.lineMain}>
              <QuotationHeader
                quotation={quotation}
                index={index}
                state={state}
                onToggleDetails={onToggleDetails}
                deleteQuotation={deleteQuotation}
                duplicateQuotation={duplicateQuotation}
                openPdf={openPdf}
                setQuotationOpened={setQuotationOpened}
                setQuotationStatus={setQuotationStatus}
                match={match}
                overOverlay={overOverlay}
                clientUuid={clientUuid}
                onOpenFinanceModal={onOpenFinanceModal}
                financeStatus={financeStatus}
              />
              <QuotationTable
                quotation={quotation}
                rlChange={rlChange}
                applyMarginFromFinanceRent={applyMarginFromFinanceRent}
                rlVehicleChange={rlVehicleChange}
                doesToggleProtectedFields={doesToggleProtectedFields}
                constantData={constantData}
                insuranceHTCalc={insuranceHTCalc}
                insuranceFinLossCalc={insuranceFinLossCalc}
                totalRentHTCalc={totalRentHTCalc}
                totalRentTTCCalc={totalRentTTCCalc}
                pricePublicTTC={pricePublicTTC}
                priceNetTTC={priceNetTTC}
                investAmtHT={investAmtHT}
                totalBenefits={totalBenefits}
                shouldHideRow={shouldHideRow}
                updateLocks={updateLocks}
                locks={locks}
                vehicle={vehicle}
                TVA_INVERT={TVA_INVERT}
                state={state}
                baseRentHT={baseRentHT}
              />
            </div>
          </div>
          <ToggleDetailButton
            onToggleDetails={onToggleDetails}
            showDetail={showDetail}
          />
          {showDetail && (
            <QuotationDetailTable
              quotation={quotation}
              dossierUuid={dossierUuid}
              rlChange={rlChange}
              resetDefault={resetDefault}
              index={index}
              doesToggleProtectedFields={doesToggleProtectedFields}
              funding={funding}
              tireData={tireData}
              constantData={constantData}
              state={state}
              financeRentCalc={financeRentCalc}
              applicationFeeCalc={applicationFeeCalc}
              mentionSel={mentionSel}
              setMentionSel={setMentionSel}
              addMention={addMention}
              onToggleDetails={onToggleDetails}
              showDetail={showDetail}
            />
          )}
        </div>
      </td>
    </tr>
  );
};

export default withRouter(ContractFinalValues);
